/** Exact text of a known, benign @tanstack/db bug (TanStack/db#1767,
 * #1783 — fixes pending, unmerged as of db 0.8.7 / react-db 0.3.7). See
 * the comment on addPageFromBlob in page-persist.ts for the full story.
 * Matched by exact message text so this can never swallow an unrelated
 * failure that happens to touch the query engine. */
const KNOWN_DB_CONGRUENCE_ERROR = "Query contributors with the same row key are not congruent";

export function isKnownDbCongruenceError(reason: unknown): boolean {
  const message = reason instanceof Error ? reason.message : String(reason);
  return message.includes(KNOWN_DB_CONGRUENCE_ERROR);
}
